import { render, staticRenderFns } from "./IsOlderSecond.vue?vue&type=template&id=c14712a8&scoped=true&lang=pug&"
import script from "./IsOlderSecond.vue?vue&type=script&lang=js&"
export * from "./IsOlderSecond.vue?vue&type=script&lang=js&"
import style0 from "./IsOlderSecond.vue?vue&type=style&index=0&id=c14712a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14712a8",
  null
  
)

export default component.exports